import React, { useState } from 'react'
import { MdCancel } from "react-icons/md";
import { BiHide, BiShow } from "react-icons/bi";
import { useFormik } from 'formik';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import SaveButton from '../../component/buttons/SaveButton';
import { changePswRes, changePswTodo } from '../../redux/Slices/LoginSlice/ChangePsw';
import { userPasswordSchema } from './validation';


export default function PasswordUpdate(props) {
    const { adminpsw, setAdminpsw } = props;
    const [currentPsw, setCurrentPsw] = useState(false);
    const [newPswShow, setNewPswShow] = useState(false);
    const [confirmPswShow, setconfirmPswShow] = useState(false);

    const dispatch = useDispatch()
    const togglePassword2 = () => {
        setCurrentPsw(!currentPsw);
    }
    const togglePassword = () => {
        setNewPswShow(!newPswShow);
    }
    const togglePassword1 = () => {
        setconfirmPswShow(!confirmPswShow);
    }

    const initialValues = {
        current_psw:'',
        new_psw: "",
        confirm_psw: ""

    };

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initialValues,
        validationSchema: userPasswordSchema,
        onSubmit: (values, action) => {
            // console.log(values)
            // dispatch(adminPswUpdateTodo(values)).then(() => pswChange())
            dispatch(changePswTodo(values)).then(() => pswChange())
            action.resetForm()
        },
    })

    const pswChange = () => {
        if (changePswRes && changePswRes.status) {
            setTimeout(() => {
                setAdminpsw(false);
            }, 1300);
            toast.success(changePswRes && changePswRes.message, { position: 'bottom-right' })
        } else {
            toast.error(changePswRes && changePswRes.message, { position: 'bottom-right' })
        }
    }

    return (
        <>
            <div className={adminpsw ? 'modal fade show d-block' : 'modal fade show d-none'} style={{ background: 'rgba(0,0,0,0.8)' }}>
                <div className="modal-dialog modal-dialog-centered modal-md  ">
                    <div className="modal-content pb-5" >
                        <div className="modal-header  "  >
                            <h5 className='text-center ' > Password Change</h5>
                            <span onClick={() => { setAdminpsw(false); }}><MdCancel style={{ color: 'red' }} size={25} className="mb-2" /></span>
                        </div>
                        <div className='modal-body  p-4 '>
                            <form onSubmit={handleSubmit}>
                            <div className='mt-2 ps-3 pe-3' style={{ position: 'relative' }}>
                                    <label htmlFor="user_name" className="form-label gh_label">Current Password</label>
                                    {currentPsw ? <span className="psw_icon" onClick={togglePassword2} ><BiShow size={20} /></span> : <span className="psw_icon" onClick={togglePassword2} ><BiHide size={20} /></span>}
                                    <input type={currentPsw ? "text" : "password"}
                                        name='current_psw'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.current_psw}
                                        className='form-control form_input' />
                                    {errors.current_psw && touched.current_psw ? (<span className='text-danger ' style={{ fontSize: "15px" }} >{errors.current_psw}</span>) : null}
                                </div>

                                <div className='mt-2 ps-3 pe-3' style={{ position: 'relative' }}>
                                    <label htmlFor="user_name" className="form-label gh_label">New Password</label>
                                    {newPswShow ? <span className="psw_icon" onClick={togglePassword} ><BiShow size={20} /></span> : <span className="psw_icon" onClick={togglePassword} ><BiHide size={20} /></span>}
                                    <input type={newPswShow ? "text" : "password"}
                                        name='new_psw'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.new_psw}
                                        className='form-control form_input' />
                                    {errors.new_psw && touched.new_psw ? (<span className='text-danger ' style={{ fontSize: "15px" }} >{errors.new_psw}</span>) : null}
                                </div>

                                <div className='mt-2 mb-4 ps-3 pe-3' style={{ position: 'relative' }}>
                                    <label htmlFor="user_name" className="form-label gh_label">Conform Password</label>
                                    {confirmPswShow ? <span className="psw_icon" onClick={togglePassword1} ><BiShow size={20} /></span> : <span className="psw_icon" onClick={togglePassword1} ><BiHide size={20} /></span>}
                                    <input type={confirmPswShow ? "text" : "password"} onChange={handleChange} onBlur={handleBlur}
                                        value={values.confirm_psw} name='confirm_psw' className='form-control form_input' />

                                    {errors.confirm_psw && touched.confirm_psw ? (<span className='text-danger ' style={{ fontSize: "15px" }} >{errors.confirm_psw}</span>) : null}
                                </div>

                                <div className='mt-3 d-flex justify-content-end'>
                                    <SaveButton name={'Update'} />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
